import { motion } from "framer-motion";

import { revealContainer as container } from "../lib/motionVariants";

// Transform-only, no opacity: on mobile the LCP element turned out to be this
// section's subhead paragraph, not the headline, and Chrome delays the LCP
// timestamp until a fading element reaches full opacity — confirmed via
// Lighthouse (mobile LCP was 5.9s, ~1.4s of it flagged as "element render
// delay" tied to this exact node). Sliding in via transform avoids that
// entirely since the content is opaque from first paint.
const slideUp = {
  hidden: { y: 16 },
  show: { y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export default function Hero() {
  return (
    <motion.section
      variants={container}
      initial="hidden"
      animate="show"
      className="border-b border-ink-200 pb-8 pt-10 sm:pt-14 md:pb-14 md:pt-[88px]"
    >
      <motion.p
        variants={slideUp}
        className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.2em] text-muted"
      >
        A website platform<br />built for type foundries<br />— Montevideo, since 2021
      </motion.p>

      <motion.h1
        variants={slideUp}
        className="mt-5 font-reactor text-[clamp(28px,9vw,132px)] font-bold leading-[0.86] -tracking-[0.01em] [font-variation-settings:'wdth'_8] md:mt-10"
      >
        YOUR TYPE,<br />PROPERLY<br />PRESENTED.
      </motion.h1>

      <motion.p
        variants={slideUp}
        className="mt-5 max-w-[46ch] text-[clamp(18px,1.6vw,22px)] leading-snug text-ink-700 md:mt-8"
      >
        Catalog, specimen pages, variable-font testers, licensing and checkout. Built with working
        foundries over five years, so the tools match how type is actually sold.
      </motion.p>

      <motion.div variants={slideUp} className="mt-7 flex flex-wrap gap-3 font-mono text-xs uppercase tracking-[0.1em]">
        <a
          href="#contact"
          className="bg-ink px-[26px] py-[14px] text-paper transition-colors duration-200 hover:bg-primary hover:text-paper"
        >
          Start your site
        </a>
        <a
          href="#in-use"
          className="border border-ink px-[26px] py-[14px] transition-colors duration-200 hover:border-primary hover:text-primary"
        >
          See a live foundry
        </a>
      </motion.div>
    </motion.section>
  );
}
